<script lang="ts">
    import { Button, DropdownShell, Label } from 'attractions';
    import Session from '../../Models/Session';
    import { EMPLOYEE_DETAILS } from '../../Stores/Session';
    import Logo from '../Logo/Logo.svelte';

    export let firstname: string;
    export let lastname: string;

    let employeeDetails;

    EMPLOYEE_DETAILS.subscribe(data => employeeDetails = data);
</script>

{#if employeeDetails.firstname}
    <section class="welcomeButton">
        <DropdownShell let:toggle>
            <Button selected on:click={() => Session.logout()}>
                <Logo height={30} style="margin-right: .5rem" />
                <div class="hello">
                    <Label small style="color: white; text-transform: capitalize">Witaj,</Label>
                    {employeeDetails.firstname} {employeeDetails.lastname}
                </div>
            </Button>
        </DropdownShell>
    </section>
{/if}

<style lang="scss">
    .welcomeButton {
        position: fixed;
        z-index: 1000;
        right: 1rem;
        top: 1rem;

        .hello {
            color: white;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }

        @media print {
            display: none;
        }
    }
</style>